"use client";
import { jsx as o } from "react/jsx-runtime";
import { s as I, r as l, u as D } from "../../chunks/usePresentationClassWithSelectors.D1eQxrvf.js";
import d from "./Icons/DIconAdd.js";
import i from "./Icons/DIconArrowDown.js";
import v from "./Icons/DIconArrowLeft.js";
import y from "./Icons/DIconArrowRight.js";
import _ from "./Icons/DIconArrowUp.js";
import x from "./Icons/DIconCaretDown.js";
import C from "./Icons/DIconCaretLeft.js";
import S from "./Icons/DIconCaretRight.js";
import b from "./Icons/DIconCaretUp.js";
import k from "./Icons/DIconCheck.js";
import A from "./Icons/DIconClose.js";
import E from "./Icons/DIconContentCopy.js";
import L from "./Icons/DIconCurrencyDollar.js";
import V from "./Icons/DIconDelete.js";
import B from "./Icons/DIconDocument.js";
import R from "./Icons/DIconDownload.js";
import U from "./Icons/DIconDrag.js";
import F from "./Icons/DIconEdit.js";
import H from "./Icons/DIconError.js";
import P from "./Icons/DIconErrorInverted.js";
import W from "./Icons/DIconExternalLink.js";
import $ from "./Icons/DIconFileCopy.js";
import j from "./Icons/DIconFilter.js";
import q from "./Icons/DIconHamburger.js";
import M from "./Icons/DIconHelp.js";
import N from "./Icons/DIconInformation.js";
import Q from "./Icons/DIconInformationExpressive.js";
import G from "./Icons/DIconInformationInverted.js";
import J from "./Icons/DIconInvisible.js";
import K from "./Icons/DIconLock.js";
import O from "./Icons/DIconLogout.js";
import T from "./Icons/DIconMoreHorizontal.js";
import X from "./Icons/DIconMoreVertical.js";
import Y from "./Icons/DIconPercent.js";
import Z from "./Icons/DIconPerson.js";
import w from "./Icons/DIconRemove.js";
import g from "./Icons/DIconSave.js";
import h from "./Icons/DIconSearch.js";
import z from "./Icons/DIconShare.js";
import rr from "./Icons/DIconStar.js";
import or from "./Icons/DIconSuccess.js";
import nr from "./Icons/DIconSuccessInverted.js";
import cr from "./Icons/DIconSustainability.js";
import tr from "./Icons/DIconUnlock.js";
import er from "./Icons/DIconVisible.js";
import mr from "./Icons/DIconWarning.js";
import ar from "./Icons/DIconWarningInverted.js";
import '../../styles/DIcon.css';const sr = "_dIcon_1y3ww_25", ur = "_sizesdefault_1y3ww_25", fr = "_sizesmd_1y3ww_25", pr = "_sizessm_1y3ww_29", Ir = "_sizeslg_1y3ww_33", lr = {
  dIcon: sr,
  sizesdefault: ur,
  sizesmd: fr,
  sizessm: pr,
  sizeslg: Ir
}, fo = ({
  analytics: t,
  ariaLabel: e,
  dataQA: m,
  extendedStyles: a,
  icon: c,
  size: r = "default",
  weight: n = "default"
}) => {
  const s = I("d-icon", m, { suffix: c }), u = l(t), f = D({
    styles: lr,
    defaultClass: "dIcon",
    selectors: {
      size: { valueSelector: r }
    },
    extendedStyles: a
  }), p = () => {
    switch (c) {
      case "add":
        return /* @__PURE__ */ o(d, { size: r, weight: n });
      case "arrow-left":
        return /* @__PURE__ */ o(v, { size: r, weight: n });
      case "arrow-right":
        return /* @__PURE__ */ o(y, { size: r, weight: n });
      case "arrow-up":
        return /* @__PURE__ */ o(_, { size: r, weight: n });
      case "arrow-down":
        return /* @__PURE__ */ o(i, { size: r, weight: n });
      case "caret-left":
        return /* @__PURE__ */ o(C, { size: r, weight: n });
      case "caret-right":
        return /* @__PURE__ */ o(S, { size: r, weight: n });
      case "caret-up":
        return /* @__PURE__ */ o(b, { size: r, weight: n });
      case "caret-down":
        return /* @__PURE__ */ o(x, { size: r, weight: n });
      case "check":
        return /* @__PURE__ */ o(k, { size: r, weight: n });
      case "close":
        return /* @__PURE__ */ o(A, { size: r, weight: n });
      case "content-copy":
        return /* @__PURE__ */ o(E, { size: r, weight: n });
      case "currency-dollar":
        return /* @__PURE__ */ o(L, { size: r, weight: n });
      case "delete":
        return /* @__PURE__ */ o(V, { size: r, weight: n });
      case "document":
        return /* @__PURE__ */ o(B, { size: r, weight: n });
      case "download":
        return /* @__PURE__ */ o(R, { size: r, weight: n });
      case "drag":
        return /* @__PURE__ */ o(U, { size: r, weight: n });
      case "edit":
        return /* @__PURE__ */ o(F, { size: r, weight: n });
      case "error":
        return /* @__PURE__ */ o(H, { size: r, weight: n });
      case "error-inverted":
        return /* @__PURE__ */ o(P, { size: r, weight: n });
      case "external-link":
        return /* @__PURE__ */ o(W, { size: r, weight: n });
      case "file-copy":
        return /* @__PURE__ */ o($, { size: r, weight: n });
      case "filter":
        return /* @__PURE__ */ o(j, { size: r, weight: n });
      case "hamburger":
        return /* @__PURE__ */ o(q, { size: r, weight: n });
      case "help":
        return /* @__PURE__ */ o(M, { size: r, weight: n });
      case "information":
        return /* @__PURE__ */ o(N, { size: r, weight: n });
      case "information-expressive":
        return /* @__PURE__ */ o(Q, { size: r, weight: n });
      case "information-inverted":
        return /* @__PURE__ */ o(G, { size: r, weight: n });
      case "invisible":
        return /* @__PURE__ */ o(J, { size: r, weight: n });
      case "lock":
        return /* @__PURE__ */ o(K, { size: r, weight: n });
      case "logout":
        return /* @__PURE__ */ o(O, { size: r, weight: n });
      case "more-horizontal":
        return /* @__PURE__ */ o(T, { size: r, weight: n });
      case "more-vertical":
        return /* @__PURE__ */ o(X, { size: r, weight: n });
      case "percent":
        return /* @__PURE__ */ o(Y, { size: r, weight: n });
      case "person":
        return /* @__PURE__ */ o(Z, { size: r, weight: n });
      case "remove":
        return /* @__PURE__ */ o(w, { size: r, weight: n });
      case "save":
        return /* @__PURE__ */ o(g, { size: r, weight: n });
      case "search":
        return /* @__PURE__ */ o(h, { size: r, weight: n });
      case "share":
        return /* @__PURE__ */ o(z, { size: r, weight: n });
      case "star":
        return /* @__PURE__ */ o(rr, { size: r, weight: n });
      case "success":
        return /* @__PURE__ */ o(or, { size: r, weight: n });
      case "success-inverted":
        return /* @__PURE__ */ o(nr, { size: r, weight: n });
      case "sustainability":
        return /* @__PURE__ */ o(cr, { size: r, weight: n });
      case "unlock":
        return /* @__PURE__ */ o(tr, { size: r, weight: n });
      case "visible":
        return /* @__PURE__ */ o(er, { size: r, weight: n });
      case "warning":
        return /* @__PURE__ */ o(mr, { size: r, weight: n });
      case "warning-inverted":
        return /* @__PURE__ */ o(ar, { size: r, weight: n });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ o(
    "svg",
    {
      "aria-label": e,
      className: f,
      "data-qa": s,
      viewBox: (() => {
        switch (r) {
          case "sm":
            return "0 0 16 16";
          case "lg":
            return "0 0 24 24";
          case "md":
          default:
            return "0 0 20 20";
        }
      })(),
      xmlns: "http://www.w3.org/2000/svg",
      ...u,
      children: p()
    }
  );
};
export {
  fo as default
};
//# sourceMappingURL=DIcon.js.map
